import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function AppointmentsInjectors() {
  useInjectReducer({ key: "appointments", reducer });
  useInjectSaga({ key: "appointments", saga });
  return null;
}
